import { helper as buildHelper } from "@ember/component/helper"

export function abbreviateWeekday(params /*, hash*/) {
  var s = params[0] || ""
  var map = {
    sunday: "Su",
    monday: "M",
    tuesday: "Tu",
    wednesday: "W",
    thursday: "Th",
    friday: "F",
    saturday: "Sa",
  }
  return map[s] || s
}

export default buildHelper(abbreviateWeekday)
